import { DesktopOutlined } from "@ant-design/icons";
import {
  InstructorLogin,
  InstructorSignUp,
  InstructorOtpVerification,
} from "pages";
import instructorRouteMap from "routeControl/instructorRouteMap";

/**
 * Generates an array of route objects for admin authentication-related pages.
 * @returns {Array} An array containing route objects for admin authentication pages.
 */
export default function route() {
  // Define a reusable icon for the routes
  const routeIcon = <DesktopOutlined />;
  return [
    // Admin Login Route
    {
      path: instructorRouteMap.LOGIN.path,
      name: "Instructor Login",
      key: instructorRouteMap.LOGIN.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <InstructorLogin />,
    },
    {
      path: instructorRouteMap.SIGN_UP.path,
      name: "Instructor Login",
      key: instructorRouteMap.SIGN_UP.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <InstructorSignUp />,
    },
    {
      path: instructorRouteMap.OTP_VERIFICATION.path,
      name: "Instructor Otp Verification",
      key: instructorRouteMap.OTP_VERIFICATION.path,
      private: false, // Public route, accessible without authentication
      belongsToSidebar: false,
      icon: routeIcon,
      element: <InstructorOtpVerification />,
    },
  ];
}
